export const SHOW_LOADER = "loader/show_loader"
export const HIDE_LOADER = "loader/hide_loader"
export const SET_LOADER = "loader/set_loader"
